import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import bg from '../../images/offer-bg.webp'
import infra from "../../images/solar.jpg"
import { useMediaQuery } from 'react-responsive';


const Offer = () => {
    const isMobile = useMediaQuery({ query: '(max-width: 991px)' });
    return (
        <div className='offer-section section-padding position-relative'
        //  style={{ backgroundImage: `url(${infra})` }}
         >
            <Container>
                <Row>
                    {
                        isMobile &&
                        <Col lg={6}>
                    <img className='infrsimage' src={infra}></img>
                    </Col>

                    }
                    <Col lg={6}>
                        <div className='position-relative offercontent'>
                            <h2 className={`text-capitalize ${isMobile ? 'mb-2': 'mb-4'}`}>Solar Plants and Renewable Energy</h2>
                            <h6 className='text-capitalize'>As advocates of a sustainable future, we design and build solar plants and renewable energy systems that help businesses reduce their carbon footprint. Harness the power of clean energy with VeeraSynergies and contribute to a greener tomorrow.</h6>
                          
                        </div>
                    </Col>
                    {
                         !isMobile &&
                         <Col lg={6}>
                         <img className='infrsimage' src={infra}></img>
                         </Col>
                    }
                   
                </Row>
            </Container>
        </div>
    )
}

export default Offer
